import React, { useState, useEffect, useContext, useRef } from "react";
import styled from "styled-components";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ActionsContext from "common/ActionsContext";
import SelectInputWithIcon from "common/SelectInputWithIcon";
import { SubscriberRatesPoliciesTable } from "../Policies/component";
import { PROFS, POLI, TYPE_PROFILE_SHORTCUTF_MAP } from "./constants";
import RulesTreeReport from "../../Rules/RulesTree";
import RulesTable from "../../Rules/RulesTable";
import ConflictsButton from "../../Rules/ConflictsButton";
import {
  Wrapper,
  TabContent,
  RulesTreeWrapper,
  SubMenuWrapper,
  SelectWrapper,
} from "../../Rules/styles";
import { a11yProps, TabPanel, handleProfChange } from "../../Rules/utils";
import MarkdownHelpModal from "common/MarkdownHelpModal";
import treeHelp from "help/viewRulesRateTree.md";
import rulesHelp from "help/viewRulesRateRules.md";
import policiesHelp from "help/viewRulesRatePolicies.md";

const _profileChoices = PROFS.map(({type, titleEdit}) => 
  ({ value: type, label: titleEdit.replace(' Profile', '')})
);
 
const titles = [
  "Subscriber rate rules and policies.",
  "List of subscriber rate rules.",
  "List of existing rate policies."
];

const SubscriberRatesTabs = ({rules, response, conflicts, tab, setTab}) => {
  const actions = useContext(ActionsContext);
  const currentTitle = titles[tab];
  const currentHelp = [treeHelp, rulesHelp, policiesHelp][tab];

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <Wrapper>
      <Tabs
        value={tab}
        onChange={handleTabChange}
        aria-label="Subscriber Rates"
        className="rulesTabs"
      >
        <Tab
          label="RULES TREE-VIEW"
          id="rulesRatesTabTree"
          {...a11yProps(0)}
          disableRipple={true}
        />
        <Tab
          label="RULES TABLE-VIEW"
          id="rulesRatesTabTable"
          {...a11yProps(1)}
          disableRipple={true}
        />
        <Tab
          label="POLICIES"
          id="rulesRatesTabPolicies"
          {...a11yProps(2)}
          disableRipple={true}
        />
      </Tabs>
      <SubMenuWrapper>
        {tab !== 2 ? (
          <button
            type="button"
            className="btn btn-default waves-effect shadow-none hidden-to-operators"
            id="rulesRatesAddRuleBtn3"
            onClick={() => actions.send("open-rule-modal", { type: "Add" })}
          >
            <i className="material-icons">add_circle</i>
            <span>Add Rule...</span>
          </button>
        ) : null}
        <button
          type="button"
          className="btn btn-default waves-effect shadow-none"
          onClick={() =>
            globalNavigate("viewPolicyRateEdit", {returnView: "viewRulesRate", tab})
          }
        >
          <i className="material-icons">add_circle</i>
          <span>Add Policy...</span>
        </button>
        {tab !== 2 ? (
          <ConflictsButton
            conflicts={conflicts}
            view="rate"
            id="rulesRatesShowConflictsBtn"
          />
        ) : null}
        {tab !== 2 ? (
          <SelectWrapper>
            Manage
            <SelectInputWithIcon
              title="Manage Profiles"
              name="profilesSelect"
              selected={"init"}
              onChange={(e) => handleProfChange(e, "viewRulesFlow")}
              options={[{ value: "init", label: "" }, ..._profileChoices]}
              className="selectProfile"
            />
            Profiles...
          </SelectWrapper>
        ) : null}
      </SubMenuWrapper>
      <TabPanel value={tab} index={0}>
        <RulesTreeReport
          response={response}
          rules={rules}
          conflicts={conflicts}
          profs={PROFS}
          poli={POLI}
          typeProfileMap={TYPE_PROFILE_SHORTCUTF_MAP}
          view="rate"
        />
      </TabPanel>
      <TabPanel value={tab} index={1}>
        <RulesTable
          rules={rules}
          conflicts={conflicts}
          view="rate"
          profs={PROFS}
          poli={POLI}
          typeProfileMap={TYPE_PROFILE_SHORTCUTF_MAP}
        />
      </TabPanel>
      <TabPanel value={tab} index={2}>
        <SubscriberRatesPoliciesTable />
      </TabPanel>
      <MarkdownHelpModal title={currentTitle} source={currentHelp} />
    </Wrapper>
  );
};

export default SubscriberRatesTabs;
